import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services';
import { WizardIcon } from '@components/icons';
import { WizardLanding } from './WizardLanding';
import { WizardResult } from './WizardResult';
import { ElectrificationSelectVehicles } from './ElectrificationSelectVehicles';
import { WizardProcessing } from './WizardProcessing';
import { WizardStart } from './WizardStart';

export const WIZARD_ROUTES: IRoute = {
	path: PortalRoutePath.WIZARD,
	icon: <WizardIcon />,
	text: <Tr.Portal path="wizard.title" />,
	canActivate: (_route, user) =>
		user?.isSellerLoggedInAsManager() ||
		(!user?.isManager() && !!user?.hasPermission([Permission.ELECTRIFICATION_WIZARD_READ, Permission.ELECTRIFICATION_WIZARD_WRITE])),
	children: [
		{
			path: '',
			element: <WizardLanding />
		},
		{
			path: 'start',
			element: <WizardStart />
		},
		{
			path: 'processing',
			element: <WizardProcessing />
		},
		{
			path: 'result',
			element: <WizardResult />
		},
		{
			path: 'select-vehicles',
			element: <ElectrificationSelectVehicles />
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '..' }} replace />
		}
	]
};
